
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<BlockNotes>({ })
export default class BlockNotes extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private isEditing!: boolean;
}
